export default class SubmitOnLoad {

	constructor() {

		$('.js-submit-on-load').submit();

	}

}